import { render } from "./DamageListComponent.vue?vue&type=template&id=77bc350a&scoped=true"
import script from "./DamageListComponent.vue?vue&type=script&lang=js"
export * from "./DamageListComponent.vue?vue&type=script&lang=js"

import "./DamageListComponent.vue?vue&type=style&index=0&id=77bc350a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bc350a"],['__file',"resources/js/components/admin/damages/DamageListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77bc350a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77bc350a', __exports__)) {
    api.reload('77bc350a', __exports__)
  }
  
  module.hot.accept("./DamageListComponent.vue?vue&type=template&id=77bc350a&scoped=true", () => {
    api.rerender('77bc350a', render)
  })

}


export default __exports__